import React from 'react';
import { Link } from 'react-router-dom';

export function Navbar() {
  return (
    <nav className="navbar is-fixed-top is-transparent" role="navigation">
      <div className="container">
        <div className="navbar-brand">
          <Link className="navbar-item" to="/">
            <img src="/sitech-logo-transparent.png" alt="Sitech eSports" style={{ maxHeight: '60px' }} />
            <span className="ml-2 has-text-white has-text-weight-bold is-size-4">Sitech eSports</span>
          </Link>
          <button className="navbar-burger has-text-white" aria-label="menu" aria-expanded="false" data-target="mainNav"
            onClick={(e) => {
              const target = document.getElementById('mainNav');
              e.currentTarget.classList.toggle('is-active');
              target?.classList.toggle('is-active');
            }}>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div id="mainNav" className="navbar-menu">
          <div className="navbar-end">
            <Link className="navbar-item has-text-white" to="/about" onClick={() => { document.getElementById("mainNav")?.classList.remove("is-active"); document.querySelector(".navbar-burger")?.classList.remove("is-active"); }}>About</Link>
            <Link className="navbar-item has-text-white" to="/services" onClick={() => { document.getElementById("mainNav")?.classList.remove("is-active"); document.querySelector(".navbar-burger")?.classList.remove("is-active"); }}>Services</Link>
            <Link className="navbar-item has-text-white" to="/games" onClick={() => { document.getElementById("mainNav")?.classList.remove("is-active"); document.querySelector(".navbar-burger")?.classList.remove("is-active"); }}>Games</Link>
            <Link className="navbar-item has-text-white" to="/news" onClick={() => { document.getElementById("mainNav")?.classList.remove("is-active"); document.querySelector(".navbar-burger")?.classList.remove("is-active"); }}>News</Link>
            <div className="navbar-item">
              <Link className="button is-primary is-small" to="/contact">Request Demo</Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
